<template>
  <div class="user-workspaces">
    <Table
      v-if="user.workspaces"
      title="User's Workspaces"
      :rows="user.workspaces"
      :fields="fields"
      @rowClick="onRowClick"
      collapsed
    />
  </div>
</template>

<script>
import Table from '@/components/Table'

export default {
  name: 'UserWorkspaces',
  components: {
    Table,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      fields: {
        title: { title: 'Title' },
        isArchived: { title: 'Archived', isBoolean: true, width: '90px' },
      },
    }
  },
  methods: {
    onRowClick(workspace) {
      this.$emit('rowClick', workspace)
    },
  },
}
</script>
